// extracted by mini-css-extract-plugin
export default {"rootContainer":"NightShiftToggle_rootContainer__+Qg12","label":"NightShiftToggle_label__9RvwJ","icon":"NightShiftToggle_icon__O-Yrk"};